import { getCase } from "../../content/lookups.js";
import type { StageDefinition } from "../../content/stages.js";
import { AttackProfile } from "../shared/AttackProfile.js";

export function BossBriefing({ stage }: { stage: StageDefinition }) {
  const bossNode = Object.values(stage.nodes).find((node) => node.caseId && getCase(node.caseId)?.isBoss);
  const boss = bossNode?.caseId ? getCase(bossNode.caseId) : undefined;
  if (!boss || !bossNode) return null;
  const required = bossNode.required ?? boss.required;
  const deadline = bossNode.deadline ?? boss.deadline;
  return <section className="boss-briefing" aria-label="ボスの事前情報">
    <header>
      <img src="/icon-boss.png" alt="" />
      <div className="boss-briefing-title">
        <p>最終プロジェクト / BOSS</p>
        <h2>{boss.name}</h2>
      </div>
      <p className="boss-briefing-stats">
        <b>{required}</b>
        <span>必要進捗 / 工期 <b>{deadline}</b></span>
      </p>
    </header>
    <p className="boss-briefing-flavor">{boss.flavor}</p>
    <AttackProfile spec={boss} />
  </section>;
}
